import React, { useEffect } from "react";
import Stage from "../../../../components/Stage";
import ButtonBack from "../../../../components/Buttons/Back";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import dataModelos from '../../../../data/AudiNuevo/modelos.json';
import ROUTES from "../../../../utilities/Routes";
import useGoogleTagManager from "../../../../hooks/useGoogleTagManager";

import { FORM_TYPES } from "../../../../data/AudiNuevo/preventa";

const ThankYou = () => {
    useGoogleTagManager(process.env.REACT_APP_ICDC_GTM_ID);

    const { modelPathName } = useParams();
    let navigate = useNavigate();
    const location = useLocation();

    const [infoNameForm, setInfoNameForm] = React.useState("Quiero un Audi nuevo");
    const [infoImage, setInfoImage] = React.useState("forms_audi_banner-quiero-un-audi-nuevo_confirmacion.jpg");

    useEffect(() => {
        document.title = "Gracias - Audi Nuevo";
    }, []);

    useEffect(() => {
        if (modelPathName === undefined) {
            /**
             * Envia evento de analytics de Form General
             */
            //console.log("Es form general");
        } else {
            /**
             * Busca si el parametro pertenece a algun modelo
             */
            if (dataModelos.find(model => model.active === true && model.pathName === modelPathName)) {
                /**
                 * Si existe el modelo en el listado
                 * Envia evento de analytics de Form por Modelo y se setea info del modelo
                 */
                let infoActualModel = dataModelos.filter(model => model.active === true && model.pathName === modelPathName)[0];

                setInfoNameForm(infoActualModel.name);
                // setInfoLink(infoActualModel.link);
                setInfoImage(infoActualModel.image);
            } else {
                /**
                 * No se encuentra el modelo, se borra el parametro y se muestra el form general
                 */
                console.log("No se encontro el modelo en base al parametro");
                navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOFORMNOTFOUND)
            }
        }
    }, [modelPathName, navigate, setInfoNameForm, setInfoImage]);

    const validateTypeForm = () => {
            const pathname = location.pathname;
    
            if (pathname.includes('/lealtad')) {
                return FORM_TYPES.PREVENTA.LEALTAD;
            } else if (pathname.includes('/conquista')) {
                return FORM_TYPES.PREVENTA.CONQUISTA;
            }
            
            return FORM_TYPES.NUEVO;
        };
    
    const formType = validateTypeForm();

    return (
        <>

            <div className="">
                <Stage  title={formType === FORM_TYPES.PREVENTA.LEALTAD || formType === FORM_TYPES.PREVENTA.CONQUISTA ? `Preventa ${infoNameForm}` : infoNameForm} img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + infoImage} positionTitle="bottom" />
                <div className="button-back-container">
                    <ButtonBack pagesToBack={2} />
                </div>
                <section className="container pb-5">
                    <div className="row pt-5">
                        <div className="col-12">
                            <h1 className="text-center">Gracias por contactarnos</h1>
                            <p className="text-center mt-5 pt-4 mb-5">Estamos procesando su solicitud, a la brevedad uno de nuestros asesores se pondrá en contacto con usted para darle seguimiento a su interés de compra.</p>
                            <p className="text-center mt-5 pt-1 mb-5">Para su comodidad y seguridad, le informamos que nos estaremos comunicando desde el número: <strong>222 179 1156</strong>, esto con la finalidad de dar seguimiento a su solicitud y atenderle como lo merece.</p>
                            <div className="text-center mb-5 pb-5">
                                <button className='button-enviar mt-5 mb-5' type='button' onClick={() =>
                                    (window.location = "https://www.audi.com.mx/mx/web/es.html")
                                }>
                                    Ir al Home
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default ThankYou;